import { today } from '@/helpers/date-helpers'
import { CURRENT_LANG } from '@/helpers/lang'

export const ACCOR_DOMAIN = '//all.accor.com'
export const API_MANAGEMENT_URL = '//api.accor.com'
export const ACCOR_STATIC_DOMAIN = '//www.ahstatic.com'
export const ACCOR_SECURE_DOMAIN = '//secure.accor.com'
export const ACCOR_WCGW_URL = '//api.wcgw.aws.accor.com'

export const API_CONTACT_URL = '/api/v3/contacts/me'
export const API_CUSTOMER_CONTACT = '/customer/v1/contacts/me'
export const API_MANAGEMENT_ORDERS = '/orders/v1/contacts/me/orders'
export const API_MANAGEMENT_ORDERS_VERSION_2 = '/orders/v2/contacts/me/orders'
export const API_CREATE_STATUS_GIFT = '/customer/v1/contacts/actions'
export const API_SELF_MERGE = '/customer/v1/contacts/me/self-merge-request'
export const API_AGGREGATE_SAVINGS = '/customer/v1/contacts/me/aggregates'
export const API_UNLINK_COBRANDS_AIRLINE = '/loyalty/v1/unlink'
export const API_VALIDATE_BURN_AUTO = '/loyalty/v1/burn/auto/validate'
export const API_LATAM_PLANS = '/latam/v1/plans'
export const API_COMPANY_EMPLOYEE = '/company/v1/employee'
export const API_COMPANY_FILES = (companyId: string) => `/company/v1/companies/${companyId}/files`
export const API_UPDATE_PASSWORD = '/contacts/v1.0/user/password'
export const API_POST_CARD_REISSUE = (cardNumber: string) =>
  `/contacts/v1.0/user/loyalty/cards/${cardNumber}/reissue`
export const API_GET_COMPANY_BY_ID = (companyId: string) => `/company/v1/companies/${companyId}`
export const API_GET_COMPANY_SETTINGS = (companyId: string) =>
  `/company/v1/companies/${companyId}/settings`
export const API_PATCH_COMPANY_BY_ID = (companyId: string) => `/company/v1/companies/${companyId}`

export const API_GET_EMPLOYEES_BY_COMPANY_ID = (companyId: string) =>
  `/company/v1/companies/${companyId}/employees`
export const API_GET_INVITATIONS_BY_COMPANY_ID = (companyId: string) =>
  `/company/v1/companies/${companyId}/invitations`
export const API_POST_INVITATIONS_BY_COMPANY_ID = (companyId: string) =>
  `/company/v1/companies/${companyId}/invitations`

export const API_GET_EMPLOYEE = '/company/v1/employee'

export const API_POST_TERMS_AND_CONDITIONS_ACCEPT =
  '/company/v1/employee/terms-and-conditions/accept'

export const API_PATCH_EMPLOYEE = (companyId: string, employeeId: string) =>
  `/company/v1/companies/${companyId}/employees/${employeeId}`

export const POST_COMPANY_ORDERS = (companyId: string) =>
  `/company/v1/companies/${companyId}/orders`

export const API_GET_COMPANY_UPLOAD_FILES = (companyId: string) =>
  `/company/v1/companies/${companyId}/files/upload/status`
export const API_GET_COMPANY_DOCUMENTS = (companyId: string) =>
  `/company/v1/companies/${companyId}/files`
export const API_SET_COMPANY_DOCUMENT = (companyId: string) =>
  `/company/v1/companies/${companyId}/files/upload`
export const API_DELETE_COMPANY_DOCUMENT = (companyId: string, fileId: string) =>
  `/company/v1/companies/${companyId}/files/${fileId}`

export const POST_COMPANY_TRANSACTIONS = (companyId: string) =>
  `/company/v1/companies/${companyId}/transactions`

export const PAGE_HOTEL = (codeHotel: string, lang: string) =>
  `${ACCOR_DOMAIN}/hotel/${codeHotel}/index.${lang}.shtml`
export const PAGE_BOOK_AGAIN = (hotel: string, lang = CURRENT_LANG) =>
  `${ACCOR_DOMAIN}/ssr/app/accor/rates/${hotel}/index.${lang}.shtml`
export const EXTERNAL_LINK = '/lien_externe.svlt'

export const OFFER = (wiseId: string, displayZone: string) =>
  `/json/${CURRENT_LANG}/offerpage/${wiseId}/${displayZone}.json`

export const PAGE_PARTNER = (partnerName: string) =>
  `/account/${CURRENT_LANG}/partner/${partnerName}`

export const PAGE_PAYMENT_CARD = (paymentCard: string) =>
  `/account/${CURRENT_LANG}/payment-card/${paymentCard}`

export const getPageUserInformationPath = () => `/account/${CURRENT_LANG}/my-information`

export const STATUS_ERROR_PAGE = `${ACCOR_DOMAIN}/loyalty-funnel/${CURRENT_LANG}/status`

export const HELP_PAGE = `/a/${CURRENT_LANG}/loyalty-program/allaccorbusiness/faq/administrator.html`

export const OrderItemsFilter = {
  isHotelBooking: 'orderType=HOTEL_BOOKING',
  isStatusActive: 'hotelBooking.status=ACTIVE*',
  hasHotelName: 'hotelBooking.hotel.name!=[null]',
  isStatusNotActive: 'hotelBooking.status!=ACTIVE*',
  isOriginTypeTARS: 'hotelBooking.origin.first.type=TARS*',
  isDepartureDateLTToday: `hotelBooking.reservation.stayInfo.departureDate<${today}`,
  isArrivalDateLTToday: `hotelBooking.reservation.stayInfo.arrivalDate<${today}`
}

export const OrderFilter = {
  isOrderItemsNonEmpty: 'orderItems!=[empty]'
}

const ORDERS_HOTEL_FIELDS =
  'name,checkInHour,media,contact,factsheetUrl,id,brand,label,localization,rating,loyaltyProgram'

export const ORDERS_FIELDS = [
  'id',
  'folderNumber',
  'invoice',
  'metaInfo.*',
  'orderItems.*',
  'orderItems.hotelBooking.*',
  `orderItems.hotelBooking.hotel[${ORDERS_HOTEL_FIELDS}]`,
  '-orderItems.hotelBooking.softBenefits',
  'orderItems.hotelBooking.reservation.*',
  'loyaltySavings.*'
]
